import { render, staticRenderFns } from "./tuikuan.vue?vue&type=template&id=6e995c87&scoped=true&"
import script from "./tuikuan.vue?vue&type=script&lang=js&"
export * from "./tuikuan.vue?vue&type=script&lang=js&"
import style0 from "./tuikuan.vue?vue&type=style&index=0&id=6e995c87&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e995c87",
  null
  
)

export default component.exports